export function scrollToTop() {
  if (typeof document === 'undefined') return false

  const container = document.getElementById('app-container')
  if (!container) return false

  container.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  return true
}

export function getBaseURL(): string {
  try {
    return `${window.location.protocol}//${window.location.host}`
  } catch (error) {
    // Does not work on server
    return process.env.NEXT_PUBLIC_ROOT_URL || 'https://flexhire.com'
  }
}
